// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parseBoolean } from "@conklin/XDL/Utilities";
import { Cart } from "@insite/client-framework/Services/CartService";

// XNG-Change: products tha has authRequiredForPurchase will be added to quote section for anonymous

export const hasProductsWithInvalidPrice = (cart: Cart | undefined, isAuthenticated: boolean) =>
    cart?.cartLines?.some(
        cartLine =>
            !cartLine.isPromotionItem &&
            !cartLine.quoteRequired &&
            !cartLine.allowZeroPricing &&
            !parseBoolean(cartLine.properties.isQuote) &&
            !(!isAuthenticated && parseBoolean(cartLine.properties.authRequiredForPurchase)) &&
            cartLine.pricing?.unitNetPrice === 0 &&
            cartLine.pricing?.unitRegularPrice === 0,
    );

export const isTopCartEmpty = (cart: Cart) => {
    return !cart?.cartLines?.some(cartLine => !cartLine.quoteRequired && !parseBoolean(cartLine.properties.isQuote));
};

export const isCartCheckoutDisabled = (cart: Cart | undefined, isAuthenticated: boolean) =>
    cart &&
    ((!cart.canCheckOut && !cart.canRequisition) ||
        isTopCartEmpty(cart) ||
        hasRestrictedCartLines(cart, isAuthenticated) ||
        hasProductsWithInvalidPrice(cart, isAuthenticated));

export const hasQuoteRequiredProducts = (cart: Cart | undefined, isAuthenticated: boolean) =>
    cart?.cartLines?.some(
        cartLine =>
            cartLine.quoteRequired ||
            parseBoolean(cartLine.properties.isQuote) ||
            (!isAuthenticated && parseBoolean(cartLine.properties.authRequiredForPurchase)),
    );

export const hasOnlyQuoteRequiredProducts = (cart: Cart | undefined, isAuthenticated: boolean) =>
    cart?.cartLines?.every(
        cartLine =>
            cartLine.quoteRequired ||
            parseBoolean(cartLine.properties.isQuote) ||
            (!isAuthenticated && parseBoolean(cartLine.properties.authRequiredForPurchase)),
    );

export const canCheckoutWithCart = (cart: Cart | undefined, isAuthenticated: boolean) => {
    return (
        cart &&
        (cart.canCheckOut ||
            hasRestrictedCartLines(cart, isAuthenticated) ||
            hasProductsWithInvalidPrice(cart, isAuthenticated))
    );
};

export const hasRestrictedCartLines = (cart: Cart | undefined, isAuthenticated: boolean) =>
    cart &&
    !!cart.cartLines &&
    cart.cartLines?.some(
        cartLine =>
            cartLine.isRestricted &&
            !cartLine.quoteRequired &&
            !parseBoolean(cartLine.properties.isQuote) &&
            !(!isAuthenticated && parseBoolean(cartLine.properties.authRequiredForPurchase)),
    );
